import apiClient from './apiClient';

export interface QueryParams {
  dateFrom?: string;
  dateTo?: string;
  vendorFrom?: string;
  vendorTo?: string;
  deptFrom?: string;
  deptTo?: string;
}

export interface ResultRow {
  source: string;
  doc_no: string;
  line_no: number;
  dept_code: string;
  dept_name: string;
  entry_date: string;
  vendor_code: string;
  item_code: string;
  item_spec: string;
  qty: number;
  amount: number;
  currency: string;
}

export interface QueryResponse {
  data: ResultRow[];
  count: number;
  message?: string;
}

export const pwj308Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pwj308/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pwj308/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
